module.exports = __webpack_public_path__ + "static/media/icon-new-client.07a3d78f.svg";